export default __webpack_public_path__ + "static/media/Prof.514bf886.jpg";